import React from 'react';
import Box from '@mui/material/Box';
import { ContractCallBase, STXTransferBase } from '@stacks/connect';
import { WalletWithIcons } from 'components/Wallet/WalletWithIcons/WalletWithIcons';
import useNetwork from 'hooks/use-network';
import { LinkIcon16 } from 'modules/icons/LinkIcon16';
import { IMultisigTransaction } from 'utils/transform-multisig-transaction';

import { STX_DECIMALS } from '../../../../constants/base';
import ReadOnlyIcon from '../../../../images/readonly_icon.svg';
import { getAccountExplorerUrl } from '../../../../utils/helper';
import { useButtonStyles } from '../../useButtonStyles';
import { useTransactionDetailStyles } from '../../useTransactionDetailStyles';

import { TransactionNonStxTokenInline } from './TransactionNonStxTokenInline';
import { useTransactionInfoStyle } from './useTransactionInfoStyle';

export const TransactionInfoInline = (props: {
  transaction: IMultisigTransaction;
  memoEvent?: any;
}) => {
  const { transaction, memoEvent = null } = props;
  const internalTxType = transaction.internalTxType;
  const [network] = useNetwork();
  const buttonClasses = useButtonStyles();
  const classes = useTransactionInfoStyle();
  const detailsClasses = useTransactionDetailStyles();

  switch (internalTxType) {
    case 'contract-call': {
      const payload = transaction.payload as STXTransferBase;
      // @ts-ignore
      if (payload.functionName === 'stack-stx')
        return (
          <div className={detailsClasses.itemWrapper}>
            <p className={detailsClasses.itemTitle}>Type</p>
            <div className={detailsClasses.itemContent}>Stacking STX</div>
          </div>
        );
      // @ts-ignore
      if (payload.functionName === 'transfer') {
        return <TransactionNonStxTokenInline payload={payload} />;
      }
      const castedPayload = transaction.payload as STXTransferBase;

      return (
        <div className={detailsClasses.itemWrapper}>
          <p className={detailsClasses.itemTitle}>Type</p>
          <div className={detailsClasses.itemContent}>
            {(castedPayload as any).contractName || 'Unknown contract-call'}
          </div>
        </div>
      );
    }
    case 'transfer-stx': {
      const payload = transaction.payload as STXTransferBase;

      return (
        <Box display="flex" flexDirection="column" gap="24px">
          <div className={detailsClasses.itemWrapper}>
            <p className={detailsClasses.itemTitle}>Type</p>
            <div className={detailsClasses.itemContent}>
              <Box display="flex" flexDirection="column" gap="4px" alignItems="flex-end">
                <Box className={classes.titleSxMb}>
                  Transfer{' '}
                  {(Number(payload.amount) / Math.pow(10, STX_DECIMALS))
                    .toFixed(STX_DECIMALS)
                    .replace(/\.?0+$/, '')}
                  STX
                </Box>
                <Box
                  className={classes.captionSxMb}
                  display="flex"
                  gap="8px"
                  alignItems="flex-start"
                  flexDirection="column"
                >
                  {memoEvent && memoEvent.type === 'STX20Protocol' && (
                    <div className={buttonClasses.stx20}>
                      +<span>{memoEvent.event.value}</span> {memoEvent.event.ticker}
                    </div>
                  )}
                  {memoEvent && memoEvent.type === 'STXSDomain' && (
                    <div className={buttonClasses.stx20}>
                      +<span>{memoEvent.event.split('.')[0]}</span>.{memoEvent.event.split('.')[1]}
                    </div>
                  )}
                  {memoEvent && memoEvent.type === 'STXSMap' && (
                    <div className={buttonClasses.stx20}>
                      +<span>{memoEvent.event.split('.')[0]}</span>.stxmap
                    </div>
                  )}
                </Box>
              </Box>
            </div>
          </div>
          <div className={detailsClasses.itemWrapper}>
            <p className={detailsClasses.itemTitle}>Receiver address</p>
            <div className={detailsClasses.itemContent}>
              <WalletWithIcons address={payload.recipient} />
            </div>
          </div>
        </Box>
      );
    }
    default:
      const payload = transaction.payload as ContractCallBase;
      const tName = payload.contractName;
      let type = 'contract call';
      if (internalTxType === 'contract-deploy') {
        type = 'contract deploy';
      }

      return (
        <div className={detailsClasses.itemWrapper}>
          <p className={detailsClasses.itemTitle}>Type</p>
          <div className={detailsClasses.itemContent}>
            <Box display="flex" gap="8px" alignItems="flex-end">
              <Box className={classes.dflexWrapSx}>
                <Box className={classes.titleSx}>
                  {tName} {type}
                </Box>
                <Box className={classes.iconSx}>
                  <img src={ReadOnlyIcon} alt="" />
                </Box>
              </Box>
              <Box className={classes.tagsSx}>
                <Box className={classes.tagSx}>{payload.functionName}</Box>
                <a
                  href={getAccountExplorerUrl(transaction.txId || '', network)}
                  target="_blank"
                  rel="noreferrer"
                  className={buttonClasses.linkIcon}
                  onClick={(event) => {
                    event.stopPropagation();
                  }}
                >
                  <LinkIcon16 />
                </a>
              </Box>
            </Box>
          </div>
        </div>
      );
  }
};
